<template>
	<div class="symptoms-progress">
		<NavBar @change-language="init" />
		<v-main>
			<v-container>
				<v-progress-linear
					:active="loading"
					:indeterminate="loading"
					top
					color="primary"
				></v-progress-linear>
				<p
					v-if="monitoredSymptoms.length == 0"
					class="font-weight-thin ml-2"
					v-translate
				>No symptoms being monitored.</p>
				<v-list v-else>
					<MonitoredSymptom
						v-for="mS in monitoredSymptoms"
						:key="mS.id"
						:monitoredSymptom="mS"
						:userType="'patient'"
						@delete-record="deleteRecord"
						@add-record="addRecord"
						@edit-record="editRecord"
					/>
				</v-list>
			</v-container>
		</v-main>
	</div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import MonitoredSymptom from "@/components/patient/MonitoredSymptom.vue";
import axios from "axios";
import Vue from 'vue';

export default {
	name: "PatientMonitoringDashboard",
	components: {
		NavBar,
		MonitoredSymptom
	},
	data: () => ({
		monitoredSymptoms: [],
		loading: false
	}),
	computed: {
		monitoredSymptomsFiltered() {
			const monitoredSymptomsByICD = {};
			this.monitoredSymptoms.forEach(mS => {
				if (monitoredSymptomsByICD[mS.disease_id])
					monitoredSymptomsByICD[mS.disease_id].push(mS);
				else monitoredSymptomsByICD[mS.disease_id] = [mS];
			});
			const monitoredSymptoms = [];
			for (var disease_id in monitoredSymptomsByICD) {
				const mSList = monitoredSymptomsByICD[disease_id];
				let mSToShow = mSList[0];
				mSList.forEach(mS => {
					if (mS.records.length > mSToShow.records.length) mSToShow = mS;
				});
				mSToShow.records.sort((a, b) => {
					const dateA = new Date(a.date + "T" + a.time);
					const dateB = new Date(b.date + "T" + b.time);
					return dateA - dateB;
				});
				monitoredSymptoms.push(mSToShow);
			}
			console.log("UPDATED");
			return monitoredSymptoms;
		}
	},
	methods: {
		init(){
			this.loading = true;
			const key = this.$route.query.key;
			const lang = Vue.config.language;
			axios
				.get("/patient/" + this.$route.params.pid + "/monitored_symptoms", {params: {key: key, lang: lang}})
				.then(response => {
					console.log(response.data);
					this.monitoredSymptoms = response.data.monitored_symptoms;
					this.loading = false;
				})
				.catch(error => {
					console.log(error);
					this.loading = false;
					this.$router.push({ name: "not-found" });
				});
		},
		addRecord(monitoredSymptom, record) {
			this.monitoredSymptoms.forEach(mS => {
				if (mS.id == monitoredSymptom.id) {
					mS.records.push(record);
				}
			});
		},
		editRecord(monitoredSymptom, record) {
			this.monitoredSymptoms.forEach(mS => {
				if (mS.id == monitoredSymptom.id) {
					mS.records.forEach((r, i) => {
						if (r.id == record.id) {
							mS.records[i].date = record.date;
							mS.records[i].time = record.time;
							mS.records[i].intensity = record.intensity;
						}
					});
				}
			});
		},
		deleteRecord(monitoredSymptom, record) {
			monitoredSymptom.records.splice(
				monitoredSymptom.records.indexOf(record),
				1
			);
			this.monitoredSymptoms.forEach(mS => {
				if (mS.id == monitoredSymptom.id) {
					mS.records = mS.records.filter(r => {
						return r.id != record.id;
					});
				}
			});
		}
	},
	created() {
		this.init();
	}
};
</script>